export default {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Products, Sellers, QC & Buying Guides',
  navSpreadsheet: 'Spreadsheet',
  navCategories: 'Categories',
  navProducts: 'Products',
  navReviews: 'Reviews',
  navShipping: 'Shipping',
  navCoupons: 'Coupons',
  navWarehouse: 'Warehouse',
  navQC: 'QC',
  navGuides: 'Guides',
  navSafety: 'Safety',
  navBlog: 'Blog',
  navAbout: 'About',
  navContact: 'Contact',
  languageSelector: 'Language',
  ctaExplore: 'Explore Spreadsheet',
  ctaBuyNow: 'Buy It Now',
  ctaMainWebsite: 'Visit Main Website',
  ctaBrowseGuides: 'Browse Buying Guides',
  heroTitle: 'AllChinaBuy Spreadsheet',
  heroSubtitle: 'Find Products, Sellers & Buying Resources Faster',
  heroDescription: 'Discover useful product lists, seller resources, QC guides, shipping information and buying tips in one organized AllChinaBuy spreadsheet hub.',
  trustLine: 'Updated resources • Practical guides • Product research • Buying & shipping information',
  whatIsTitle: 'What Is the AllChinaBuy Spreadsheet?',
  whatIsDesc: 'The AllChinaBuy spreadsheet is a convenient way to organize and explore product resources, seller information, buying guides and related research. Our goal is to make product discovery and purchasing research easier by bringing useful resources together in one searchable hub.',
  exploreResources: 'Explore AllChinaBuy Resources',
  popularCategories: 'Popular AllChinaBuy Spreadsheet Categories',
  latestGuides: 'Latest AllChinaBuy Guides',
  shippingCost: 'AllChinaBuy Shipping & Cost Guides',
  shippingCostDesc: 'Learn about shipping methods, cost factors, delivery considerations and practical research tips for your AllChinaBuy orders.',
  reviewTitle: 'AllChinaBuy Review & Legitimacy Guide',
  reviewDesc: 'Find neutral information about platform experience, safety considerations, account security, payment awareness and how users can independently verify information.',
  compareTitle: 'Compare Before You Buy',
  compareDesc: 'Use comparison tables to evaluate sellers, products, shipping options, QC standards, prices, warehouses, coupons and buying methods.',
  safetyTitle: 'Stay Safe When Shopping',
  safetyDesc: 'Learn essential safety tips and best practices for online shopping and research. Visit our Safety Center for detailed guidance.',
  finalCTATitle: 'Ready to Explore the AllChinaBuy Spreadsheet?',
  finalCTADesc: 'Browse our latest spreadsheet resources, guides, comparisons and buying information.',
  footerRights: 'All rights reserved.',
  footerDisclaimer: 'This site is an independent resource hub. All information is for research purposes only.',
  footerLinks: 'Quick Links',
  footerResources: 'Resources',
  footerLegal: 'Legal',
  footerSitemap: 'Sitemap',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Use',
  readMore: 'Read More',
  updated: 'Updated',
  resourceSpreadsheet: 'AllChinaBuy Spreadsheet',
  resourceReviews: 'AllChinaBuy Reviews',
  resourceShipping: 'AllChinaBuy Shipping Cost',
  resourceWarehouse: 'AllChinaBuy Warehouse',
  resourceCoupons: 'AllChinaBuy Coupons',
  resourceDiscounts: 'AllChinaBuy Discount Codes',
  resourceLegit: 'AllChinaBuy Legit & Safety',
  resourceQC: 'AllChinaBuy QC Guides',
  categoryClothing: 'Clothing',
  categoryShoes: 'Shoes',
  categoryAccessories: 'Accessories',
  categoryElectronics: 'Electronics',
  categoryBags: 'Bags',
  categoryStreetwear: 'Streetwear',
  categoryHome: 'Home & Lifestyle',
  categoryPopular: 'Popular Finds',
  categorySellers: 'Trusted Sellers',
  categoryQC: 'QC Resources',
  aboutTitle: 'About AllChinaBuy Spreadsheet',
  aboutDesc: 'We are an independent resource hub dedicated to helping buyers research and organize AllChinaBuy product information.',
  contactTitle: 'Contact Us',
  contactDesc: 'Have questions or suggestions? We would love to hear from you.',
  safetyCenter: 'Safety Center',
  safetyCenterDesc: 'Essential safety tips and best practices for online shopping and research.',
  allchinabuySpreadsheet: 'AllChinaBuy spreadsheet',
  allchinabuyReview: 'AllChinaBuy review',
  allchinabuyShipping: 'AllChinaBuy shipping cost',
  allchinabuyCoupon: 'AllChinaBuy coupon',
  allchinabuyDiscount: 'AllChinaBuy discount code',
  allchinabuyWarehouse: 'AllChinaBuy warehouse',
  allchinabuyLegit: 'AllChinaBuy legit',
  allchinabuyQC: 'AllChinaBuy QC',
  allchinabuySellers: 'AllChinaBuy sellers',
  allchinabuyProducts: 'AllChinaBuy products',
  allchinabuyGuide: 'AllChinaBuy buying guide',
  breadcrumbHome: 'Home',
  breadcrumbBlog: 'Blog',
  breadcrumbAbout: 'About',
  breadcrumbContact: 'Contact',
  breadcrumbSafety: 'Safety',
  metaHomeTitle: 'AllChinaBuy Spreadsheet – Products, Sellers, QC & Buying Guides',
  metaHomeDesc: 'Explore the AllChinaBuy spreadsheet with product lists, seller resources, QC guides, shipping information, reviews, coupons and practical buying tips.',
  metaAboutTitle: 'About AllChinaBuy Spreadsheet – Resource Hub',
  metaAboutDesc: 'Learn about the AllChinaBuy Spreadsheet resource hub. Independent research platform for product discovery, seller reviews and buying guides.',
  metaContactTitle: 'Contact AllChinaBuy Spreadsheet – Get in Touch',
  metaContactDesc: 'Contact the AllChinaBuy Spreadsheet team for questions, suggestions or resource requests.',
  metaSafetyTitle: 'Safety Center – AllChinaBuy Spreadsheet Shopping Tips',
  metaSafetyDesc: 'Stay safe while researching AllChinaBuy. Learn about account security, payment awareness, phishing prevention and safe browsing practices.',
  metaArticleTitle: 'AllChinaBuy Spreadsheet Guide – Buying Resources & Tips',
  metaArticleDesc: 'Detailed guides and articles about AllChinaBuy spreadsheet resources, buying tips, shipping costs and seller research.',
  relatedArticles: 'Related Articles',
  backToHome: 'Back to Home',
  feature: 'Feature',
  option: 'Option',
  bestFor: 'Best For',
  shippingMethod: 'Shipping Method',
  speed: 'Speed',
  cost: 'Cost',
  tracking: 'Tracking',
  seller: 'Seller',
  category: 'Category',
  price: 'Price',
  notes: 'Notes',
  warehouse: 'Warehouse',
  function: 'Function',
  storage: 'Storage',
  qc: 'QC',
  lastModified: '2026-08-25',
  author: 'Editorial Team',
  published: 'Published',
  lastUpdated: 'Last Updated',
  tableOfContents: 'Table of Contents',
  quickAnswer: 'Quick Answer',
  detailedExplanation: 'Detailed Explanation',
  practicalGuide: 'Practical Guide',
  prosAndCons: 'Pros & Cons',
  commonMistakes: 'Common Mistakes',
  safetyNotes: 'Safety Notes',
  faq: 'FAQ',
  ctaFunnel: 'Continue exploring AllChinaBuy resources or visit our main website for more products.',
  visitMain: 'Visit Main Website',
  spreadsheetGuide: 'AllChinaBuy Spreadsheet Complete Guide',
  couponDesc: 'Discover the latest AllChinaBuy coupons, discount codes, promotional offers and how to apply them to save on your orders.',
  warehouseDesc: 'Understand AllChinaBuy warehouse operations, storage processes, QC procedures and how inventory management works.',
  qcDesc: 'Learn how to read QC photos, inspect products, identify quality issues and make informed decisions before shipping.',
  spreadsheetGuideDesc: 'A comprehensive guide to understanding and using the AllChinaBuy spreadsheet for product research and buying decisions.',
  featuredProducts: 'Featured Products',
  featuredProductsDesc: 'Browse our curated selection of popular products from the AllChinaBuy spreadsheet. Click any item to buy now.',
  viewAllProducts: 'View All Products',
  buyNow: 'Buy Now',
  productCatalog: 'Product Catalog',
  productCatalogDesc: 'Browse our curated selection of products from AllChinaBuy spreadsheet. Click any item to purchase directly.',
  allProducts: 'All Products',
  items: 'items',
  noProducts: 'No products in this category.',
  lookingForMore: 'Looking for More Products?',
  visitFullStore: 'Visit Full Store',
  heroTrustUpdated: 'Updated Resources',
  heroTrustPractical: 'Practical Guides',
  heroTrustResearch: 'Product Research',
  categoryBrowseDesc: 'Browse product categories and explore the AllChinaBuy spreadsheet',
  showLess: 'Show Less',
  showAllCategories: 'Show All Categories',
  resourceCardDesc: 'Explore resources and guides for',
  articlesDesc: 'Latest articles about AllChinaBuy spreadsheet, buying guides and product research',
  shippingDisclaimer: 'Check current information before purchase. Shipping times and costs may vary.',
  latestResources: 'Latest Resources',
  email: 'Email',
  responseTime: 'Response Time',
  website: 'Website',
  sendMessage: 'Send Message',
  fillRequired: 'Please fill in all required fields.',
  messageTooLong: 'Message must be 500 characters or less.',
  thankYouMessage: 'Thank you for your message! We will get back to you soon.',
  safeBrowsingChecklist: 'Safe Browsing Checklist',
  verifyHTTPS: 'Verify HTTPS',
  verifyHTTPSDesc: 'Always check for the padlock icon and HTTPS prefix before entering any personal information.',
  strongPasswords: 'Use Strong Passwords',
  strongPasswordsDesc: 'Create unique passwords with a mix of letters, numbers, and symbols. Consider using a password manager.',
  twoFactorAuth: 'Enable Two-Factor Authentication',
  twoFactorAuthDesc: 'Add an extra layer of security to your accounts whenever the platform supports it.',
  researchBeforeBuy: 'Research Before You Buy',
  researchBeforeBuyDesc: 'Take time to read seller reviews, compare prices, and verify product details before making purchases.',
  keepRecords: 'Keep Records',
  keepRecordsDesc: 'Save order confirmations, tracking numbers, and communication with sellers for reference and dispute resolution.',
  reportSuspicious: 'Report Suspicious Activity',
  reportSuspiciousDesc: 'If you encounter suspicious sellers, fake websites, or phishing attempts, report them to the platform immediately.',
  safetyDisclaimer: 'This safety information is provided for educational purposes. We cannot guarantee the safety of any platform, seller, or transaction. Always conduct your own research and exercise judgment when shopping online.',
  pageNotFound: 'Page not found',
  pageNotFoundDesc: 'The page you are looking for does not exist or has been moved.',
  productCardDesc: 'Explore resources and guides for',
};